const n = "partnerLink";
export {
  n as MENU_PARTNER_LINK
};
